import { useQuery } from '@tanstack/react-query'
import { listScenarioCatalog } from '../api'

export const scenarioCatalogQueryKey = ['scenarios', 'catalog'] as const

/**
 * Catalogue of scenarios used by filter pickers across the app
 * (alerts queue, cases search, reports, etc.). Cached aggressively —
 * scenarios mutate on admin edits, not in the analyst hot path. Admin
 * mutations invalidate `['scenarios', …]` so the catalogue refreshes
 * on the same cache key family.
 */
export function useScenarioCatalog() {
  return useQuery({
    queryKey: scenarioCatalogQueryKey,
    queryFn: listScenarioCatalog,
    staleTime: 5 * 60_000,
  })
}
